



















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { queryTerm, downloadZip } from '@/api/document';
import subFile from '@/components/document/subFile.vue';
import { downloadFile } from '@/assets/js/download';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { hasPermission } from '@/utils/utils';
import { mapGetters } from 'vuex';

interface option {
  name: string;
  id: string;
}

interface selectOptions {
  id?: string;
  opthions?: option[];
}

interface permissions {
  hasQuery: boolean;
  hasDownload: boolean;
}

const queryTypeMap = {
  1: 'fundId',
  2: 'companyIds',
  3: 'roundIds',
  4: 'fileTypeIds',
  5: 'originalCode'
};

@Component({ 
  components: { draggable, subFile },
  computed: { ...mapGetters(['userInfo'])}
})
class FileExtraction extends Vue {
  @Prop()
  tags;

  @Prop()
  fileType;

  userInfo: any;
  num: Number = 0;
  selectedList: any[] = [];
  defaultList: any[] = [];
  tagList: any[] = [];
  selectOptions: selectOptions = {};
  queryTypeMap: Object = queryTypeMap;
  selectedObj: Object = {};
  fileList: any[] = [];
  currentId: String = '';
  typeList: any[] = [];
  hasMore: boolean = false;
  showFiles: any[] = [];
  page: number = 1;
  pageSize: number = 99;
  isChooseDownload: boolean = false;
  folderNameList: any[] = [];
  permissions: permissions = {
    hasQuery: false,
    hasDownload: false
  };
  selectedIds: object = {};
  queriedList: any[] = [];
  showSelected: object = {};
  hasFund: boolean = false;
  loading: boolean = false;
  // qureyObj: object = {};
  resetRound: boolean = false;

  @Watch('selectedList')
  selectedListChange(val) {
    let { selectedList } = this;
    this.hasFund = selectedList.some(e => {
      return e.id === 1;
    });
  }

  get downloadNum() {
    return this.$store.state.fileExtraction.downloadList.length;
  }

  created() {
    const { permissions:queue } = this.userInfo || {};
    this.permissions.hasQuery = hasPermission(queue, '/document/fileExtraction/projectQuery');
    this.permissions.hasDownload = hasPermission(queue, '/document/fileExtraction/fileDownload');
  }

  mounted() {
    this.tagList = this.tags;
  }

  @Getter('token') token;

  toChange(e) {
    if (e.added.element) {
      let item = e.added.element;
      //@ts-ignore
      this.$ga.gaUploadCustomEvent('文档-文件调取-拖动标签',item.name);
      if (item.id === 1) {
        this.selectedList.unshift(item);
      } else {
        this.selectedList.push(item);
      }
      if (item.id !== 5) {
        this.initSelection(item.id, this.hasFund, 1);
      }
    }
  }

  async initSelection(id, hasFund, page) {
    try {
      let res;
      if (hasFund && this.selectedObj[1]) {
        let fundId = this.selectedObj[1][0].id;
        res = await queryTerm({ fileType: this.fileType, queryType: id, fundId: fundId, page: page, pageSize: this.pageSize });
      } else if (id === 3) {
        let companyIds = '';
        if (this.selectedObj.hasOwnProperty('2') && this.selectedObj[2] && this.selectedObj[2].length > 0) {
          companyIds = this.selectedObj[2]
            .map(_ => {
              return _.id;
            })
            .join(',');
        }
        let data = { fileType: this.fileType, queryType: id, page: page, pageSize: this.pageSize };
        if (companyIds) {
          data['companyIds'] = companyIds;
        }
        this.resetRound = false;
        res = await queryTerm(data);
      } else {
        res = await queryTerm({ fileType: this.fileType, queryType: id, page: page, pageSize: this.pageSize });
      }
      if (res.code === 200) {
        if (this.selectOptions.hasOwnProperty(id)) {
          this.selectOptions[id] = this.selectOptions[id].concat(res.data.list);
        } else {
          this.$set(this.selectOptions, id, res.data.list);
        }
        if (res.data.total && res.data.total > page * this.pageSize) {
          this.initSelection(id, hasFund, page + 1);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  onMove(e) {
    if (e.relatedContext.element.id === 1) return false;
    return true;
  }

  deleteTag(item) {
    this.selectedList = this.selectedList.filter(e => {
      return e.id !== item.id;
    });
    if (item.id === 1 && this.selectedObj[1] && this.selectedObj[1].length > 0) {
      this.selectedList.forEach(e => {
        if (e.id !== 5) {
          this.initSelection(e.id, false, 1);
          this.selectedObj[e.id] = [];
          delete this.selectedObj[e.id];
          this.showSelected[e.id] = [];
          delete this.showSelected[e.id];
          this.selectedObj[e.id] = [];
          this.selectOptions[e.id] = [];
          delete this.selectOptions[e.id];
        }
      });
    }
    if (item.id === 2) {
      this.selectedObj[3] = [];
      this.showSelected[3] = [];
      delete this.selectedObj[3];
      delete this.showSelected[3];
      this.resetRound = true;
    }
    if (item.id === 3) {
      this.resetRound = false;
    }
    this.selectedObj[item.id] = [];
    delete this.selectedObj[item.id];
    this.showSelected[item.id] = [];
    delete this.showSelected[item.id];
    this.selectOptions[item.id] = [];
    delete this.selectOptions[item.id];
    this.tagList.push(item);
  }

  queryFile() {
    if (this.selectedList && this.selectedList.length > 0 && Object.keys(this.selectedObj).length > 0) {
      let selectedList = this.selectedList.filter(e => {
        return this.selectedObj.hasOwnProperty(e.id.toString()) && this.selectedObj[e.id.toString()].length > 0;
      });
      if (selectedList.length > 0) {
        this.typeList = selectedList.slice(0);
        this.num = this.typeList.length || 0;
        this.fileList = [];
        this.showFiles = [];
        this.selectedIds = {};
        this.page = 1;
        this.queriedList = [];
        let selectedObj = JSON.parse(JSON.stringify(this.selectedObj));
        for (let key in selectedObj) {
          selectedObj[key].forEach(e => {
            if (this.selectedIds.hasOwnProperty(key)) {
              this.selectedIds[key].push(e.id || e.name);
            } else {
              this.selectedIds[key] = [e.id || e.name];
            }
          });
        }
        this.fileList = selectedObj[this.typeList[0].id];
        this.fileList.forEach(e => {
          e.unfold = false;
        });
        if (this.fileList.length > this.pageSize) {
          this.hasMore = true;
        }
        this.getShowFiles();
        this.$store.commit('fileExtraction/files', this.fileList);
      } else {
        this.fileList = [];
      }
    } else {
      this.fileList = [];
    }
  }

  getShowFiles() {
    if (this.showFiles.length !== this.fileList.length) {
      this.hasMore = true;
      this.showFiles = this.showFiles.concat(
        this.fileList.slice(
          this.pageSize * (this.page - 1),
          this.pageSize * this.page > this.fileList.length ? this.fileList.length : this.pageSize * this.page
        )
      );
      this.page++;
      if (this.showFiles.length === this.fileList.length) {
        this.hasMore = false;
      }
    }
  }

  handleChange(val, id) {
    let data;
    if (Array.isArray(val)) {
      data = val.map(item => {
        return { name: item.label, id: item.key };
      });
    } else {
      data = {};
      for (let key in val) {
        if (key === 'label') {
          data['name'] = val['label'];
        } else if (key === 'key') {
          data['id'] = val['key'];
        }
      }
    }
    if (id === 1) {
      this.selectedObj[id] = [];
      this.selectedObj[id].push(data);
      this.selectedList.forEach(e => {
        if (e.id !== 1) {
          if (e.id !== 5) {
            this.initSelection(e.id, this.hasFund, 1);
            this.selectedObj[e.id] = [];
            this.showSelected[e.id] = [];
            delete this.selectedObj[e.id];
            delete this.showSelected[e.id];
            this.selectOptions[e.id] = [];
            delete this.selectOptions[e.id];
          }
        }
      });
      return;
    }
    if (id === 2) {
      // debugger;
      this.selectedObj[3] = [];
      this.showSelected[3] = [];
      delete this.selectedObj[3];
      delete this.showSelected[3];
      this.resetRound = true;
    }
    this.selectedObj[id] = data;
  }

  changeCode(e, id) {
    let val = e.target.value;
    if (val.trim()) {
      this.selectedObj[id] = [{ name: val, id: val }];
    } else {
      delete this.selectedObj[id];
    }
  }

  chooseDownload() {
    this.isChooseDownload = true;
    this.$store.commit('fileExtraction/chooseDownload', true);
  }

  cancelDownload() {
    this.isChooseDownload = false;
    this.$store.commit('fileExtraction/chooseDownload', false);
    this.$store.commit('fileExtraction/downloadList', []);
    this.$store.commit('fileExtraction/fileSize', 0);
  }

  async downLoad() {
    if (this.downloadNum > 100) {
      this.$message.error('选择的文件个数超过限制');
    } else if (this.downloadNum === 0) {
      this.$message.error('请选择下载文件');
    } else {
      try {
        this.loading = true;
        let downloadList = this.$store.state.fileExtraction.downloadList;
        let res = await downloadZip({ fileType: this.fileType, fileFolderList: downloadList });
        if (res.code === 200) {
          this.loading = false;
          const downloadPath = res.data + '?Authorization=' + this.token;
          downloadFile(downloadPath);
          this.$store.commit('fileExtraction/chooseDownload', false);
          this.$store.commit('fileExtraction/downloadList', []);
          this.$store.commit('fileExtraction/fileSize', 0);
          this.isChooseDownload = false;
        } else {
          this.$message.error('下载失败');
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        this.$message.error('下载失败');
        console.log(err);
      }
    }
  }

  filterOption(value, option) {
    return option.componentOptions.children[0].text.indexOf(value) >= 0;
  }

  handleSelect(val) {
    if (this.resetRound) {
      this.selectedObj[3] = [];
      this.showSelected[3] = [];
      delete this.selectedObj[3];
      delete this.showSelected[3];
      this.selectOptions[3] = [];
      delete this.selectOptions[3];
      let companyIds = '';
      if (this.selectedObj.hasOwnProperty('2') && this.selectedObj[2] && this.selectedObj[2].length > 0) {
        companyIds = this.selectedObj[2]
          .map(_ => {
            return _.id;
          })
          .join(',');
      }
      this.initRound(companyIds, 1);
    }
  }

  async initRound(ids, page) {
    let body = { fileType: this.fileType, queryType: 3, page: page, pageSize: this.pageSize };
    if (ids) {
      body['companyIds'] = ids;
    }
    let res = await queryTerm(body);
    if (res.code === 200) {
      if (this.selectOptions.hasOwnProperty('3')) {
        this.selectOptions[3] = this.selectOptions[3].concat(res.data.list);
      } else {
        this.$set(this.selectOptions, 3, res.data.list);
      }
      if (res.data.total && res.data.total > page * this.pageSize) {
        this.initRound(ids, page + 1);
      } else {
        this.resetRound = false;
      }
    }
  }
}
export default FileExtraction;
